export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-1440w.593d974d.avif";